// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student_form_wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 16px;
  box-sizing: border-box;
  background: #f5f6fa;

}

.student_form_card {
  width: 100%;
  max-width: 630px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 32px 28px;
  box-sizing: border-box;
    margin-top: 50px;
}

.student_form_title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 24px;
  color: #1a1a2e;
  text-align: center;
}

.student_form_form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.student_form_group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.student_form_label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.student_form_input,
.student_form_textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #d8dae0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  color: #1a1a2e;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.student_form_input:focus,
.student_form_textarea:focus {
  outline: none;
  border-color: #4a6cf7;
}

.student_form_textarea {
  resize: vertical;
  min-height: 50px;
}

.student_form_error {
  font-size: 12px;
  color: #e63946;
}

.student_form_checkbox_group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.student_form_checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #4a6cf7;
}

.student_form_checkbox_label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
}

.student_form_submit_btn {
  margin-top: 8px;
  padding: 13px 20px;
  background: #4a6cf7;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.student_form_submit_btn:hover {
  background: #3a5ce0;
}

.student_form_submit_btn:disabled {
  background: #a7b3f5;
  cursor: not-allowed;
}

.student_form_status_success {
  font-size: 14px;
  color: #2a9d5c;
  text-align: center;
}

.student_form_status_error {
  font-size: 14px;
  color: #e63946;
  text-align: center;
}

/* Mobile responsive - down to 360px */
@media (max-width: 480px) {
  .student_form_card {
    padding: 24px 18px;
  }

  .student_form_title {
    font-size: 20px;
  }

  .student_form_input,
  .student_form_textarea {
    font-size: 14px;
    padding: 10px 12px;
  }
}

@media (max-width: 360px) {
  .student_form_wrapper {
    padding: 24px 10px;
  }

  .student_form_card {
    padding: 20px 14px;
  }

  .student_form_title {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/STUDENTPLATFORM/StudentForm/StudentForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;IACpB,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".student_form_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 40px 16px;\n  box-sizing: border-box;\n  background: #f5f6fa;\n\n}\n\n.student_form_card {\n  width: 100%;\n  max-width: 630px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  padding: 32px 28px;\n  box-sizing: border-box;\n    margin-top: 50px;\n}\n\n.student_form_title {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 24px;\n  color: #1a1a2e;\n  text-align: center;\n}\n\n.student_form_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.student_form_group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.student_form_label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.student_form_input,\n.student_form_textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1px solid #d8dae0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-family: inherit;\n  color: #1a1a2e;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease;\n}\n\n.student_form_input:focus,\n.student_form_textarea:focus {\n  outline: none;\n  border-color: #4a6cf7;\n}\n\n.student_form_textarea {\n  resize: vertical;\n  min-height: 50px;\n}\n\n.student_form_error {\n  font-size: 12px;\n  color: #e63946;\n}\n\n.student_form_checkbox_group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.student_form_checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #4a6cf7;\n}\n\n.student_form_checkbox_label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  cursor: pointer;\n}\n\n.student_form_submit_btn {\n  margin-top: 8px;\n  padding: 13px 20px;\n  background: #4a6cf7;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.student_form_submit_btn:hover {\n  background: #3a5ce0;\n}\n\n.student_form_submit_btn:disabled {\n  background: #a7b3f5;\n  cursor: not-allowed;\n}\n\n.student_form_status_success {\n  font-size: 14px;\n  color: #2a9d5c;\n  text-align: center;\n}\n\n.student_form_status_error {\n  font-size: 14px;\n  color: #e63946;\n  text-align: center;\n}\n\n/* Mobile responsive - down to 360px */\n@media (max-width: 480px) {\n  .student_form_card {\n    padding: 24px 18px;\n  }\n\n  .student_form_title {\n    font-size: 20px;\n  }\n\n  .student_form_input,\n  .student_form_textarea {\n    font-size: 14px;\n    padding: 10px 12px;\n  }\n}\n\n@media (max-width: 360px) {\n  .student_form_wrapper {\n    padding: 24px 10px;\n  }\n\n  .student_form_card {\n    padding: 20px 14px;\n  }\n\n  .student_form_title {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
